import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useEffect, useState } from 'react'
import { Cross, OrangeSpinner } from '@components/icons'
import { HomePageService } from '@services/homePage/index.service'
import { getComponents } from '@components/home/helper'
import { CURRENT_HOME_COMPONENT_PAGE, EmptyString } from '@components/utils/constants'
import { DeviceType } from '@commerce/utils/use-device'

export default function CmsPage({ open, setOpen, data, handleCmsModalOpen }: any) {
  const deviceInfo = {
    isMobile: true,
    isOnlyMobile: false,
    isDesktop: false,
    isIPadorTablet: false,
    deviceType: DeviceType.UNKNOWN,
    isDeviceTypeLoaded: true,
  }

  const [loader, setLoader] = useState(false)
  const [cmsData, setCmsData] = useState<any>(null)

  const getCmsData = async (slug: any) => {
    let res: { data?: any } = {};
    setLoader(true)
    res = await HomePageService.retrievePageContent({
      slug: `pages${slug}`,
      workingVersion: process.env.NODE_ENV === 'production' ? true : true, // TRUE for preview, FALSE for prod.
      channel: 'MobileWeb',
    })
    setLoader(false)
    return res
  }

  const generateComponents = (key: any) => {
    const showPadding = cmsData?.hidepadding
      ? cmsData?.hidepadding?.toLowerCase() === 'true'
        ? false
        : true
      : false
    const cmsNoPaddingLayout = true
    return getComponents(
      key,
      cmsData,
      deviceInfo,
      showPadding,
      CURRENT_HOME_COMPONENT_PAGE.OTHERS,
      cmsNoPaddingLayout
    )
  }

  useEffect(() => {
    const slug = data?.link || EmptyString
    const fetchCmsData = async () => {
      if (open && slug && !cmsData) {
        try {
          const cmsResData = await getCmsData(slug);
          if (cmsResData?.data) {
            setCmsData({
              ...cmsResData?.data,
              colvideoview: 'mob',
            });
          } else {
            handleCmsModalOpen(false);
          }
        } catch (error) {
          console.error('err', error)
          handleCmsModalOpen(false);
        }
      } else {
        handleCmsModalOpen(false);
      }
    }
    fetchCmsData()
  }, [])

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => handleCmsModalOpen(false)}
        >
          <div className="fixed inset-0 left-0 bg-orange-900/20" />
          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="fixed inset-y-0 right-0 flex max-w-full pointer-events-none bottom-to-top">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-400"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-400"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="w-screen max-w-md pointer-events-auto">
                    <div className="relative z-50 flex flex-col h-full bg-white shadow-xl cvv-mobile-position sm:bg-white mob-width-full hide-scrollbar-visibility">
                      <div className="relative z-10 px-6 py-2 border-b border-gray-200 sm:py-6 sm:px-6 sm:left-1 right-1 sm:relative top-1">
                        <div className="flex flex-col w-full">
                          <div className="w-full">
                            <button
                              type="button"
                              className="mr-2 text-black rounded-md outline-none hover:text-gray-500"
                              onClick={() => handleCmsModalOpen(false)}
                            >
                              <Cross
                                className="relative w-6 h-6 sm:w-8 sm:h-8 sm:top-1"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="relative z-50 flex flex-col h-full overflow-y-auto bg-white shadow-xl hide-scrollbar-visibility">
                        <div className="pb-6 pt-1 overflow-y-auto search-result scroll-bar-width-0">
                          {!cmsData || loader ? (
                            <div className="bg-white cs-loader-box h-full w-full flex items-center justify-center">
                              <OrangeSpinner className="animate-spin" />
                            </div>
                          ) : (
                            <>
                              {Object?.keys(cmsData)?.map((key: any) => {
                                return generateComponents(key)
                              })}
                            </>)
                          }
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}
